import { addItem, getItem, removeItem } from '../../../utils/common';

function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export const file2FolderConversionBuilder = ({
  foldersTree,
  conversionRes,
  movedItemRes,
  convertedFileToFolder,
  isSourceFile,
  isSourceApiFile = false,
}) => {
  let foldersList = deepCopy(foldersTree);
  const copiedMovedItemRes = { ...movedItemRes };

  if (movedItemRes) {
    if (!isSourceFile && !isSourceApiFile) {
      movedItemRes = getItem(foldersTree, copiedMovedItemRes?.id);
      copiedMovedItemRes.parent_id_id = copiedMovedItemRes.parent_id_id;
    }
    const { data, draft, markdown_data, is_draft_published, ...movedData } = copiedMovedItemRes;
    foldersList = addItem(removeItem(foldersList, movedData?.id), movedData);
  }
  if (convertedFileToFolder && conversionRes) {
    const { ...convertedData } = conversionRes;
    foldersList = addItem(removeItem(foldersList, convertedData?.id), convertedData);
    foldersList = removeItem(foldersList, convertedData?.meta_info?.default_file);
    const isMovedItemFolder = 'parent_id_id' in copiedMovedItemRes;
    const parentLookupKey = isMovedItemFolder ? 'parent_id_id' : 'folder_id';
    const isMoveItemInsideNewFolder = copiedMovedItemRes[parentLookupKey] === convertedData?.id;
    if (isMoveItemInsideNewFolder) {
      if (isMovedItemFolder) {
        foldersList = addItem(foldersList, copiedMovedItemRes);
      } else {
        foldersList = addItem(foldersList, copiedMovedItemRes);
      }
    }
    return { foldersList };
  }

  return { foldersList };
};

export default file2FolderConversionBuilder;
